import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, props } from '@ngrx/store';
import { Account } from '@zero/shared/util-models';

export const moneyAccountActions = createActionGroup({
  source: 'Money Account',
  events: {
    'Set Loading': props<{ loading: boolean }>(),
    'Load Account': props<{ force: boolean }>(),
  },
});

export const moneyAccountApiActions = createActionGroup({
  source: 'Money Account API',
  events: {
    'Load Account Success': props<{ account: Account }>(),
    'Load Account Failure': props<{ error: HttpErrorResponse }>(),
  },
});
